import { useEffect, useState } from "react";

let designerSelectedItem: DesignerSelectedItem = { stepIndex: 0 };
let changeListeners: ((newItem: DesignerSelectedItem, oldItem: DesignerSelectedItem) => void)[] = [];

export interface DesignerSelectedItem {
    stepIndex: number;
    formItemIndex?: number;
}

export default function useDesignerSelectedFormItem() {
    let [selectedItem, setSelectedItem] = useState<DesignerSelectedItem>(designerSelectedItem);
    useEffect(() => {
        let listener = (newItem: DesignerSelectedItem, oldItem: DesignerSelectedItem) => setSelectedItem(newItem);
        changeListeners.push(listener);
        return () => {
            changeListeners = changeListeners.filter(l => l !== listener);
        }
    });
    return selectedItem;
}

export function designSurveyItem(newSelectedItem: DesignerSelectedItem) {
    let oldSelectedItem = designerSelectedItem;
    designerSelectedItem = newSelectedItem;
    changeListeners.forEach(l => l(designerSelectedItem, oldSelectedItem));
}

export function onDesignerSelectedItemChange(listener: (newItem: DesignerSelectedItem, oldItem: DesignerSelectedItem) => void) {
    changeListeners.push(listener);
    return () => {
        changeListeners = changeListeners.filter(l => l !== listener);
    };
}

export function getDesignerSelectedItem() {
    return designerSelectedItem;
}